import { useEffect } from "preact/hooks";
import { WISHLIST_UPDATED_EVENT } from "./wishlistCache";
const SESSION_KEY = "swym_wishlist_cache";
const notify = () => window.dispatchEvent(new Event(WISHLIST_UPDATED_EVENT));
const saveToSession = () => {
    try {
        if (window.swymWishLists) {
            sessionStorage.setItem(SESSION_KEY, JSON.stringify(window.swymWishLists));
        }
    }
    catch (_a) { }
};
const loadFromSession = () => {
    var _a, _b;
    try {
        const raw = sessionStorage.getItem(SESSION_KEY);
        if (raw) {
            window.swymWishLists = JSON.parse(raw);
            window.swymSelectedListId = (_b = (_a = window.swymWishLists) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.lid;
            return true;
        }
    }
    catch (_c) { }
    return false;
};
export const toNumericId = (id) => {
    const s = String(id);
    if (s.includes("/"))
        return s.split("/").pop() || s;
    return s;
};
export const convertToSwymProduct = (productId, handle, variantId) => {
    var _a;
    if (!variantId)
        return null;
    return {
        epi: toNumericId(variantId),
        empi: toNumericId(productId),
        du: `https://${(_a = window.Shopify) === null || _a === void 0 ? void 0 : _a.shop}/products/${handle}`,
    };
};
export const checkIfWishlisted = (swymProduct) => {
    if (!window.swymWishLists || !swymProduct)
        return false;
    return window.swymWishLists.some((list) => {
        var _a;
        return (_a = list.listcontents) === null || _a === void 0 ? void 0 : _a.some((item) => String(item.empi) === String(swymProduct.empi) &&
            String(item.epi) === String(swymProduct.epi));
    });
};
export const addToWishlist = (swat, swymProduct) => {
    var _a;
    const lid = window.swymSelectedListId;
    if (!lid)
        return;
    // Optimistic, update local data and notify before the api call
    const list = (_a = window.swymWishLists) === null || _a === void 0 ? void 0 : _a.find((l) => l.lid === lid);
    if (list) {
        if (!list.listcontents)
            list.listcontents = [];
        const exists = list.listcontents.some((item) => String(item.empi) === String(swymProduct.empi) &&
            String(item.epi) === String(swymProduct.epi));
        if (!exists)
            list.listcontents.push(Object.assign({}, swymProduct));
    }
    saveToSession();
    notify();
    swat.addToList(lid, swymProduct, () => {
        saveToSession();
    }, (error) => {
        console.error("Error adding to wishlist:", error);
        // Rollback if fails
        if (list === null || list === void 0 ? void 0 : list.listcontents) {
            list.listcontents = list.listcontents.filter((item) => !(String(item.empi) === String(swymProduct.empi) &&
                String(item.epi) === String(swymProduct.epi)));
        }
        saveToSession();
        notify();
    });
};
export const removeFromWishlist = (swat, swymProduct) => {
    const lid = window.swymSelectedListId;
    if (!lid)
        return;
    // Optimistic, update local data and notify before the api call
    const removed = [];
    for (const list of window.swymWishLists || []) {
        if (!list.listcontents)
            continue;
        list.listcontents = list.listcontents.filter((item) => {
            const match = String(item.empi) === String(swymProduct.empi) &&
                String(item.epi) === String(swymProduct.epi);
            if (match)
                removed.push(item);
            return !match;
        });
    }
    saveToSession();
    notify();
    swat.deleteFromList(lid, swymProduct, () => {
        saveToSession();
    }, (error) => {
        var _a;
        console.error("Error removing from wishlist:", error);
        // Rollback if fails
        const list = (_a = window.swymWishLists) === null || _a === void 0 ? void 0 : _a.find((l) => l.lid === lid);
        if (list && removed.length) {
            if (!list.listcontents)
                list.listcontents = [];
            list.listcontents.push(...removed);
        }
        saveToSession();
        notify();
    });
};
const syncFromGlobal = () => {
    var _a;
    if (!window.swymWishLists)
        return;
    if (!window.swymSelectedListId)
        window.swymSelectedListId = (_a = window.swymWishLists[0]) === null || _a === void 0 ? void 0 : _a.lid;
    saveToSession();
    notify();
};
const init = (swat) => {
    if (window.__swymInitialised)
        return;
    window.__swymInitialised = true;
    window._swat = swat;
    // If the swym app widget already populated the lists, just sync
    if (window.swymWishLists) {
        syncFromGlobal();
        return;
    }
    // Swym's widget populates window.swymWishLists on its own, so poll for it
    const poll = setInterval(() => {
        if (window.swymWishLists) {
            clearInterval(poll);
            syncFromGlobal();
        }
    }, 500);
};
export const useSwymInit = () => {
    useEffect(() => {
        // Load cached wishlist from sessionStorage immediately for instant hearts
        if (!window.swymWishLists && loadFromSession()) {
            notify();
        }
        // If swymWishLists appeared from swym's own widget between page loads, sync now
        if (window.swymWishLists) {
            syncFromGlobal();
        }
        if (!window.SwymCallbacks)
            window.SwymCallbacks = [];
        window.SwymCallbacks.push(init);
    }, []);
};
